@keyframes slide {
	from {
		transform: var(--origin);
		opacity: 0;
	}

	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.base {
}

.tooltip {
	isolation: isolate;
	font: var(--lp-text-body-2-regular);
	padding: var(--lp-spacing-200) var(--lp-spacing-300);
	border-radius: var(--lp-border-radius-regular);
	background-color: var(--lp-color-bg-overlay-secondary);
	box-shadow:
		0px 0px 1px 0px var(--lp-color-shadow-ui-primary),
		0px 1px 2px 0px var(--lp-color-shadow-ui-primary),
		0px 2px 8px 0px var(--lp-color-shadow-ui-secondary);
	color: var(--lp-color-text-ui-primary-base);
	transform: translate3d(0, 0, 0);
	will-change: transform, opacity;
	max-width: var(--lp-size-400);
	overflow: auto;

	&[data-placement='top'] {
		--origin: translateY(4px);
	}

	&[data-placement='bottom'] {
		--origin: translateY(-4px);
	}

	&[data-placement='right'] {
		--origin: translateX(-4px);
	}

	&[data-placement='left'] {
		--origin: translateX(4px);
	}

	@media (prefers-reduced-motion: no-preference) {
		&[data-entering] {
			animation-name: slide;
			animation-duration: var(--lp-duration-200);
			animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
		}
	}

	& kbd {
		color: var(--lp-color-gray-100);
		background-color: var(--lp-color-gray-900);
		border: 1px solid var(--lp-color-gray-700);
		box-shadow: inset 0 -1px 0 var(--lp-color-gray-700);
	}
}
